import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { intersectionBy } from 'lodash-es';

import { IBusinessAttribute } from 'app/business-attributes/business-attribute.model';

import { IBusinessAttributesFacetOption } from './business-attributes-facet-option.model';

@Component({
  selector: 'cc-business-attributes-facet',
  templateUrl: './business-attributes-facet.component.html',
  styleUrls: ['./business-attributes-facet.component.scss'],
})
export class BusinessAttributesFacetComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() options: IBusinessAttribute[];
  @Input() selectedOptions: IBusinessAttribute[];
  @Input() clearFilters: EventEmitter<void>;

  @Output() selection = new EventEmitter<IBusinessAttribute[]>();

  model: IBusinessAttributesFacetOption[] = [];
  constructor() {}
  ngOnInit(): void {
    this.clearFilters?.subscribe(() => {
      this.model.forEach((option) => {
        option.checked = false;
      });
      this.onSelectionChange();
    });
  }

  ngOnChanges(): void {
    this.model = this.options?.map((option) => ({
      ...option,
      name: option.name || option.description,
      checked: !!this.selectedOptions?.some((selectedOption) => selectedOption.code === option.code),
    }));
  }

  toggleOption(option: IBusinessAttributesFacetOption): void {
    option.checked = !option.checked;
    this.onSelectionChange();
  }

  onSelectionChange() {
    const selectionModel = this.model.filter((opt) => opt.checked);
    const originalOptionsSelection = intersectionBy(this.options, selectionModel, (opt) => opt.code);

    this.selection.emit(originalOptionsSelection);
  }
}
